<template>
  <div id="app-onboarding" class="view-wrapper" data-naver-offset="214" data-menu-item="#layouts-navbar-menu"
    data-mobile-item="#home-sidebar-menu-mobile" :class="{ 'is-pushed-full': $store.state.isSubmenuActive }">
    <div class="page-content-wrapper">
      <div class="page-content is-relative">
        <div class="page-title has-text-centered tabs-wrapper">
          <!-- Sidebar Trigger -->
          <sidebar />

          <div class="title-wrap">
            <h1 class="title is-4">Manage Careers </h1>
          </div>
          <toolbar />
        </div>
        <div class="datatable-toolbar">
          <div class="select">
            <select class="datatable-filter datatable-select form-control" data-filter="position"
              data-filter-type="default" v-model="perPage" @change="filterData">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          &nbsp;entries per page

          <div class="buttons">
            <button type="button" class="button h-button is-primary ">
              <export-excel class="btn btn-default" :data="careers" :fields="json_fields" name="Career List.xls">
                Download List
              </export-excel>
            </button>
            <div class="control mr-2">
              <input v-model="searchText" @keyup="filterData" class="input custom-text-filter" placeholder="Search..." />
              <div class="form-icon">
                <i data-feather="search"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="page-content-inner">
          <!-- Datatable -->
          <div class="table-wrapper" data-simplebar>
            <table id="users-datatable" class="table is-datatable is-hoverable table-is-bordered">
              <thead>
                <tr>
                  <th>
                    <div class="control">#</div>
                  </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>More</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                <tr data-id="0" v-for="(data, index) in this.careers" :key="data.id">
                  <td>
                    <div class="control">
                      {{ parseInt(perPage) * (currentPage - 1) + index + 1 }}
                    </div>
                  </td>
                  <td class="wrap">
                    <a download target="_blank"
                      v-if="data.attachment && (['jpg', 'png', 'svg', 'doc', 'docx', 'pdf', 'csv', 'txt'].includes(data.attachment.split('.').pop()))"
                      :href="data.attachment" class="pl-2"> <i class="lnil lnil-download"></i></a> &nbsp;&nbsp;
                    <span class="
                                                                    has-dark-text
                                                                    dark-inverted
                                                                    is-font-alt is-weight-600
                                                                    rem-90
                                                                  ">
                      {{ data.name }}
                    </span>
                  </td>
                  <td>
                    {{ data.email }}
                  </td>
                  <td>
                    {{ data.phone }}
                  </td>
                  <td>
                    Skills: {{ data.skills }}<br>
                    Linkedin: {{ data.linkedin }}<br>
                    Xing: {{ data.xing }}
                  </td>
                  <td>
                    {{ data.message }}
                  </td>
                </tr>
              </tbody>

            </table>
            <div class="section-placeholder" v-if="this.careers.length == 0">
              <div class="placeholder-content">
                <img class="light-image" src="img/illustrations/placeholders/search-4.svg" alt="">
                <img class="dark-image" src="img/illustrations/placeholders/search-4-dark.svg" alt="">
                <h3 class="dark-inverted">No data to show</h3>
                <p>There is currently no data to show in this list.</p>
              </div>
            </div>
          </div>

          <div id="paging-first-datatable" v-if="this.careers.length != 0" class="
                                                          pagination
                                                          datatable-pagination
                                                          pagination-datatables
                                                          text-center
                                                        ">
            <pagination v-model="currentPage" :per-page="parseInt(perPage)" :records="total" @paginate="filterData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
import dataProcess from '../../util/dataProcess';
export default {
  name: "home",
  data() {
    return {
      careers: [],
      bkcareers: [],
      buttonloader: [],
      total: 0,
      type: "",
      index: "",
      show: 0,
      currentPage: 1,
      searchText: "",
      perPage: 10,
      tempObject: '',
      aList: [],
      json_fields: {
        'Name': 'name',
        'Email': 'email',
        'Phone': 'phone',
        'Skills': 'skill',
        'Linkedin': 'linkedin',
        'Xing': 'xing',
        'Message': 'message',
        'Attachment': 'attachment'
      },
    };
  },
  created() {
    this.$store.state.isDetailLoading = false;
  },
  mounted() {
    this.getData();
  },

  beforeMount() { },

  methods: {
    getData() {
      this.$store.state.isDetailLoading = true;
      dataProcess
        .getData(this.$path + "api/" + this.$store.state.appLocale.langId + "/d" + this.$store.state.appDevice.id + "/career/list")
        .then((response) => {
          if (response.status == 200) {
            if (response.data) {
              this.bkcareers = response.data.data;
              this.filterData();
            }
            this.$store.state.isDetailLoading = false;
          } else {
            this.total = 0;
          }
        });
    },
    filterData() {
      let searchText = this.searchText.toLowerCase().trim();
      let filterdData;
      if (searchText != "") {
        filterdData = this.bkcareers.filter(
          (el) =>
            (el.name && el.name.toLowerCase().indexOf(searchText) > -1)
        );
      } else {
        filterdData = this.bkcareers;
      }
      this.total = filterdData.length;
      if (this.currentPage > 1) {
        let noOfPages = Math.ceil(this.total / parseInt(this.perPage));
        this.currentPage = noOfPages >= this.currentPage ? this.currentPage : noOfPages;
      }
      this.careers = filterdData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );

    },
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.getData();
    },
    '$store.state.appDevice': function (newVal, oldVal) {
      this.getData();
    }
  },
  metaInfo: {
    title: "Skiy31 :: View Careers",
  },
};
</script>
<style>
.vue-csv-uploader-part-two {
  display: none;
}

.center-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
}

.file-input {
  height: auto;
}

#import-modal .column {
  padding: 0px;
}

.form-fieldset {
  padding: 20px 0;
  max-width: 480px;
  margin: 0 38px;
}
</style>